<ng-containter *ngIf="canManageEmailFooters || canEditGlobal">
  <app-loader *ngIf="!emailFooters"></app-loader>

  <ng-container *ngIf="emailFooters">
    <div class="row mt-4">
      <div class="col">
        <h3>Email Footers</h3>
      </div>

      <div class="col">
        <button
          class="btn btn-raised btn-success float-right"
          (click)="createEmailFooter()"
        >
          New Email Footer
        </button>
      </div>
    </div>

    <div class="row mt-1">
        <div class="col">
            <i>
                For use of creating footers for each departmental function used across multiple email 
                notification types within one or more workflows.  Making edits to the footer here will 
                automatically update it in all locations it is currently used (click on USAGE).
            </i>
        </div>
    </div>

    <div class="row ml-2 mt-3" *ngIf="emailFooters.length === 0">
        <div class="flex-col pt-2">
            <i>No Email Footers to display</i>
        </div>
    </div>

    <table class="table mt-3 text-left" *ngIf="emailFooters.length > 0">
      <tbody>
        <tr>
          <th>Label</th>
          <th>Enabled</th>
          <th></th>
          <th></th>
          <th></th>
          <!-- <th></th> -->
        </tr>
        <tr *ngFor="let ef of emailFooters">
          <td>
            {{ ef.label }}
          </td>
          <td>
            {{ ef.isEnabled ? 'Yes' : 'No' }}
          </td>
          <td>
            <ng-container *ngIf="ef.isEnabled">
              <button
                class="btn btn-raised btn-danger"
                (click)="changeEnabledStatus(ef.id, false)"
              >
                Disable
              </button>
            </ng-container>
            <ng-container *ngIf="!ef.isEnabled">
              <button
                class="btn btn-raised btn-primary"
                (click)="changeEnabledStatus(ef.id, true)"
              >
                Enable
              </button>
            </ng-container>
          </td>
          <td>
            <div *ngIf="ef.inUse">
              <button
                class="btn btn-primary btn-sm"
                (click)="viewFooterUsage(ef.id)"
              >
                View Usage
              </button>
            </div>
            <div 
              *ngIf="!ef.inUse"
              class="badge badge-pill badge-warning"
            >
              Not in use
            </div>
          </td>
          <td>
            <button
              class="btn btn-primary btn-sm"
              (click)="editEmailFooter(ef)"
            >
              Edit
            </button>
          </td>
          <!-- <td>
              <button 
                class="btn btn-primary btn-sm" 
                (click)="deleteEmailFooter(ef.id)"
              >
                Delete
              </button>
          </td> -->
        </tr>
      </tbody>
    </table>
  </ng-container>

  <wm-modal-confirm
    #deleteEmailFooterModal
    [showButtonText]="true"
    [showButton]="false"
    commandText="Yes"
    title="Delete Email Footer"
    (accepted)="deleteEmailFooter(deletingEmailFooterId, true)"
    btnColor="danger"
    class="mx-2"
    [closeOnAccept]="false"
  >
    Are you sure you want to delete this Email Footer?
  </wm-modal-confirm>

  <wm-modal-confirm
    #emailFooterEditorModal
    [showButton]="false"
    commandText="Save"
    title="Email Footer"
    (accepted)="saveEmailFooter(true)"
    (canceled)="cancelEditing()"
    btnColor="success"
    class="mx-2"
    [closeOnAccept]="false"
    [form]="form"
  >
    <wm-email-footer-editor
      #emailFooterEditor
      *ngIf="editingEmailFooter"
      [emailFooter]="editingEmailFooter"
      [form]="form"
    ></wm-email-footer-editor>
  </wm-modal-confirm>

  <wm-modal-confirm
    #emailFooterUsageModal
    [showButton]="false"
    [showButtonText]="false"
    [showCancelButton]="false"
  >
    <app-loader *ngIf="loadingWorkflowActivities"></app-loader>

    <ng-container *ngIf="!loadingWorkflowActivities">
      <table class="table mt-3 text-left" *ngIf="workflowActivities.length > 0">
        <tbody>
          <tr>
            <th>Workflow</th>
            <th>Activity</th>
            <th></th>
          </tr>
          <tr *ngFor="let a of workflowActivities">
            <td>
              {{ a.workflowName }}
            </td>
            <td>
              {{ a.activityName }}
            </td>
            <td>
              <a
                target="_blank"
                [routerLink]="['/admin/workflow-builder/', a.workflowId]"
                [queryParams]="{ activityId: a.activityId }"
              >
                Workflow Builder
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </wm-modal-confirm>
</ng-containter>
